/**
 * Low-level transport for analytics events.
 *
 * Sends a JSON body to the analytics endpoint using sendBeacon (preferred)
 * with a fetch fallback. Both the single-event and batch-event paths share
 * this so the sending logic lives in one place.
 */
export const sendToEndpoint = (
  url: string,
  token: string,
  body: string,
): void => {
  // Prefer sendBeacon — it survives page unload.
  if (navigator.sendBeacon) {
    const endpoint = new URL(url);
    endpoint.searchParams.set("token", token);
    const isSent = navigator.sendBeacon(endpoint.toString(), body);
    if (isSent) return;
    console.warn("sendBeacon failed, falling back to fetch");
  }

  // Fall back to fetch if sendBeacon is unavailable or fails.
  void fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `${token}`,
    },
    body,
    keepalive: true,
  }).catch((error: unknown) => {
    console.warn("Analytics fetch failed", error);
  });
};
